import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'src/client/redux';
import { isPrerender } from 'src/client/utils/prerenderDetect';

export const AuthFrame = () => {
  const { user, loaded: userLoaded } = useSelector((state) => state.auth);
  const siteUUID = useSelector((state) => state.site.UUID);
  const ssoUrl = useSelector((state) => state.app.ssoUrl);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [ssoResponded, setSsoResponded] = useState(false);
  const shouldRender = !isPrerender && !user && userLoaded;

  useEffect(() => {
    const iframe = iframeRef.current;

    if (!iframe || !shouldRender) {
      return () => {};
    }

    const ssoReceiveMessage = (event: MessageEvent) => {
      if (event.source !== iframe.contentWindow || event.origin !== ssoUrl) {
        return;
      }

      setSsoResponded(true);

      if (event.data === true) {
        window.location.href = `/auth/man?r=${window.location.pathname}`;
      }
    };

    let ssoTimeout: ReturnType<typeof setTimeout> | undefined;
    const pingSSO = () => {
      if (ssoResponded) {
        return true;
      }

      iframe.contentWindow?.postMessage('ping', '*');
      ssoTimeout = setTimeout(pingSSO, 1000);
      return false;
    };

    pingSSO();
    window.addEventListener('message', ssoReceiveMessage, false);

    return () => {
      if (ssoTimeout) {
        clearTimeout(ssoTimeout);
      }
      window.removeEventListener('message', ssoReceiveMessage, false);
    };
  }, [shouldRender, ssoResponded, ssoUrl]);

  if (!shouldRender) {
    return null;
  }

  return (
    <iframe
      title="sso"
      id="auth-iframe"
      src={`${ssoUrl}/auth/iframe/${siteUUID}`}
      style={{ display: 'none' }}
      ref={iframeRef}
    />
  );
};
